import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, HostListener, OnInit, ViewChild,  Inject,  PLATFORM_ID } from '@angular/core';
import { NavigationStart, Router, RouterModule } from '@angular/router';
import { ApplyLoan, KeyFactModel, LoanRequestModel } from '../../Models/loan-request.model';
import { CreditGeniusService } from '../../../Services/credit-genius.service';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { LoanPurposeType } from '../../Models/EnumHelper';
import { GetLoanYears } from '../../CommonUtility/util';
import { LoanItem, LoanSearchModel } from '../../Models/user-data.model';
import { CommonHelperService } from '../../CommonUtility/common-helper.service';
import { CommonModule, LocationStrategy,isPlatformBrowser  } from '@angular/common';
import { NavbarComponent } from '../../Components/navbar/navbar.component';
import { FooterComponent } from '../../Components/footer/footer.component';
import { DefaultCurrencyPipe } from "../../Extras/CustomPipes/default-currency-pipe/default-currency.pipe";
declare var $: any;
@Component({
  selector: 'app-result-page',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NavbarComponent,
    FooterComponent,
    DefaultCurrencyPipe
],
  templateUrl: './result-page.component.html',
  styleUrls: ['./result-page.component.css'],
  providers: [NgbModalConfig, NgbModal]
})
export class ResultPageComponent implements OnInit {
  OneForm!: FormGroup;
  imgSrc = environment.imgBasURL;
  LoanList: LoanItem[] = [];
  keyfact = new KeyFactModel('', '', '', '', '', '');
  LoanDuration: any;
  PurposeType: number = 1;
  Amount: number = 500;
  TermYear!: number;
  LoanTermOnSlider: number = 6;
  TermTypes: string = 'months';
  toolTipGuaranteedRate = environment.TooltipLoansGuaranteedRate;
  toolTipVariableRate = environment.TooltipLoansVariableRate;
  toolTipPreApproved = environment.TooltipForPreApproved100;
  toolTip100 = environment.TooltipForPreApproved100;
  @ViewChild('sliderAmount') amountSlider!: ElementRef;
  @ViewChild('sliderMonth') monthSlider!: ElementRef;
  submitted = false;
  IsUpdateResult: boolean = false;
  PurposeTypeEnum = LoanPurposeType;
  LoanType!: string;
  SortBy: string;
  SortByName: string;

  TitleAmount: number;
  TitleTermYear: number;
  TitleTermTypes: string;
  IsBackButtonCliced!: boolean;

  Additional_CriteriaLink: any;

  constructor(
    config: NgbModalConfig,
    private modalService: NgbModal,
    private _creditGeniusService: CreditGeniusService,
    private _commonHelper: CommonHelperService,
    private router: Router,
    private fb: FormBuilder,
    private location:LocationStrategy,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
      if (isPlatformBrowser(this.platformId)) {
    if (localStorage.getItem('loanprefrence') !== null) {
      const storageData = localStorage.getItem('loanprefrence');

      if (storageData !== null) {
          const storageValue = JSON.parse(storageData);
      if (storageValue != null) {
        this.PurposeType = storageValue.LoanPurpose === null ? this.PurposeType : storageValue.LoanPurpose;
        this.LoanType = _commonHelper.GetLoanType(this.PurposeType);
        this.Amount = storageValue.LoanAmount === null ? this.Amount : storageValue.LoanAmount;
        this.LoanTermOnSlider = storageValue.LoanTerm === null ? this.LoanTermOnSlider : storageValue.LoanTerm;
        this.TermYear = (this.LoanTermOnSlider >= 12) ? GetLoanYears(this.LoanTermOnSlider) : this.LoanTermOnSlider;
        this.TermTypes = (this.LoanTermOnSlider >= 12) ? 'yrs' : (this.LoanTermOnSlider == 12) ? 'yr' : 'mths';
      }}
    }}

    this.TitleAmount = this.Amount;
    this.TitleTermYear = this.TermYear;
    this.TitleTermTypes = this.TermTypes;
    this.SortBy = 'Eligibility';
    this.SortByName='Eligibility';
  }
  ngOnInit(): void {

    this.OneForm = this.fb.group({
      LoanAmount: [this.Amount, [Validators.required, Validators.min(500), Validators.max(25000)]],
      LoanTerm: [this.LoanTermOnSlider, Validators.required],
    });

    this.GetEligibilityBasedLoan(0);
    if (isPlatformBrowser(this.platformId)) {
    window.scrollTo(0, 0)}
  }

  get f() {
    return this.OneForm.controls;
  }
  modal(content:any) {
    this.modalService.open(content,
      { windowClass: 'custom-class' }
    );
  }
  open(content:any, cardId:any) {
    this.modalService.open(content,
      { windowClass: 'custom-class' }
    );

    const loanItem = this.LoanList.find(cc => cc.cardId === cardId);
    this.keyfact = loanItem?.loanKeyFacts
  ? JSON.parse(loanItem.loanKeyFacts) as KeyFactModel
  : new KeyFactModel('', '', '', '', '', '');

    this.Additional_CriteriaLink = this.LoanList.filter(cc => cc.cardId == cardId)[0]['linkUrl'];
  }

  popUpClose() {
    this.modalService.dismissAll();
  }

  GetEligibilityBasedLoan(origin: number) {

    if (origin == 0) {
      this.IsUpdateResult = false;

    }
    if (origin == 1) {
      this.IsUpdateResult = true;
    }

        if (isPlatformBrowser(this.platformId)) {
    const data: LoanRequestModel = {
      LoanPurpose: this.PurposeType,
      LoanAmount: Number(this.f['LoanAmount'].value),
      LoanDuration: Number(this.f['LoanTerm'].value),
      CustomerId: sessionStorage.getItem('customer') || '',
      BrowserName:window.navigator.userAgent
      //BrowserName: "chrome"
    };

    this._creditGeniusService.GetEligibilityBasedLoan(data).subscribe(
      (result) => {
        this.IsUpdateResult = false;
        if (result.data != null && result.data.length > 0) {
          this.LoanList = result.data;
          const dataList = result.data as LoanItem[];
          var eligibleData = dataList.filter((cc: LoanItem) => cc.eligibilityPercentage > 19);

          if (eligibleData != undefined && eligibleData.length > 0) {
            this.LoanList = result.data;
            this.LoanList = this.LoanList.sort((a, b) => b.eligibilityPercentage - a.eligibilityPercentage);
            this.TitleAmount = data.LoanAmount || 0;
            this.TitleTermYear = data.LoanDuration || 0;
            this.TitleTermTypes = 'months';
          }
          else {
            this.navigatePrimeInfo();
          }
        }
        else {
          this.navigatePrimeInfo();
        }

      },
      (err: HttpErrorResponse) => {
        this.IsUpdateResult = false;
        console.log('Catch exception: ' + err);
      }
    );}
  }

  navigatePrimeInfo() {
    const loanSearchModel: LoanSearchModel = {
      LoanPurpose: this.PurposeType,
      LoanAmount: Number(this.f['LoanAmount'].value),
      LoanTerm: Number(this.f['LoanTerm'].value),
      LoanType: this.LoanType
    };
    localStorage.setItem('loanprefrence', JSON.stringify(loanSearchModel));
    this.router.navigate(['/primeInfo']);
  }

  Sorting(event: any) {
    var sortingType = event;
    switch (sortingType) {
      case 'EligibilityPercentageD': {
        this.LoanList = this.LoanList.sort((a, b) => b.eligibilityPercentage - a.eligibilityPercentage);
        this.SortBy = 'Eligibility (High to Low)';
        this.SortByName='Eligibility';
        break;
      }
      case 'AnnualInterestAPRA': {
        this.LoanList = this.LoanList.sort((a, b) => (a.annualInterestAPR > b.annualInterestAPR) ? 1 : -1);
        this.SortBy = 'Representative APR (Low to High)';
        this.SortByName='Representative APR';
        break;
      }
      case 'MonthlyRepaymentA': {
        this.LoanList = this.LoanList.sort((a, b) => (a.monthlyRepayment > b.monthlyRepayment) ? 1 : -1);
        this.SortBy = ' Monthly Payment (Low to High)';
        this.SortByName='Monthly Payment';
        break;
      }
      case 'TotalRepayableAmountA': {
        this.LoanList = this.LoanList.sort((a, b) => (a.totalRepayableAmount > b.totalRepayableAmount) ? 1 : -1);
        this.SortBy = 'Total Repayable (Low to High)';
        this.SortByName='Total Repayable';
        break;
      }
      case 'providerNameA': {
        this.LoanList = this.LoanList.sort((a, b) => (a.providerName.toUpperCase() > b.providerName.toUpperCase()) ? 1 : -1);
        this.SortBy = 'Loan Name (A-Z)';
        this.SortByName='Loan Name';
        break;
      }
      case 'providerNameD': {
        this.LoanList = this.LoanList.sort((a, b) => (a.providerName.toUpperCase() < b.providerName.toUpperCase()) ? 1 : -1);
        this.SortBy = 'Loan Name (Z-A)';
        this.SortByName='Loan Name';
        break;
      }
    }

    this.router.navigate(['/result'], { queryParams: { sortby: sortingType } });
  }

  ApplyLoan(url: string, LogId: number, ProductId: number, ProdName: string, CorelationalId: string) {
    const applyloam: ApplyLoan =
    {
      CustomerId: sessionStorage.getItem('customer') || '',
      SectionId: 2,
      LogId: LogId,
      ProductId: ProductId,
      ProductName: ProdName,
      CorrelationId: CorelationalId

    }
    this._creditGeniusService.LoanRequestLogger(applyloam).subscribe((res: any) => {
      if (res.statusCode > 0) {
      }
    });
    window.open(url, '_blank');
  }


  changeSlider(event:any, control: string) {
    let value = event.target.value;

    if (control == 'LoanAmount') {
      this.Amount = value;
    }
    else if (control == 'LoanTerm') {

      if (value >= 12) {
        this.TermTypes = value == 12 ? 'yr' : 'yrs';
        this.TermYear = GetLoanYears(value);
      }
      else {
        this.TermTypes = 'mths';
        this.TermYear = value;
      }
    }
  }

  LoanPurpose(purpose: number, loanType: string) {
    this.PurposeType = purpose;
    this.LoanType = loanType;
  }

  LoanAmounts(event:any) {

    let value = isNaN(parseInt(event.target.value)) ? 0 : parseInt(event.target.value);
    if (value < 500) {
      value = 500;
    }
    else {
      if ((value % 250) > 0) {
        let v = value - (value % 250);
        value = (v + 250);
      }
    }
    this.Amount = value;
    this.OneForm.controls['LoanAmount'].setValue(value);
    this.amountSlider.nativeElement.value = value;
  }

  displayLoanList(data:any) {
    this.LoanList = data;
  }

}


